import {
	DatePickerInputProps,
	DatePickerInput as NativeDatePickerInput,
} from '@mantine/dates';

// Styles
import classes from './DatePickerInput.module.css';
import './style.css';

// Icons
import { em } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconCalendarWeek } from '@tabler/icons-react';

export const DatePickerInput = (
	props: DatePickerInputProps<'range'>
) => {
	const isMobile = useMediaQuery(
		`(max-width: ${em(750)})`
	);

	return (
		<NativeDatePickerInput
			classNames={classes}
			dropdownType={isMobile ? 'modal' : 'popover'}
			popoverProps={{
				position: 'bottom-end',
			}}
			leftSection={
				<IconCalendarWeek
					color="var(--mantine-color-igluTextSecondary-9)"
					size={'24px'}
					stroke={1.5}
				/>
			}
			{...props}
		/>
	);
};
